import { ConsumerSource } from '@outdoorly/chat-sdk';
import { useState, useEffect } from 'react';

/**
 * @param source the ConsumerSource to subscribe to
 * @param def the default value for the consumer source, in case it hasn't yet emitted
 * @returns
 */
export const useSubscription = <T>(source: ConsumerSource<T>, def: T): T => {
  const [state, setState] = useState(source.value() ?? def);
  useEffect(() => source.toCallback(setState).unsubscribe, [source]);
  return state;
};
